<template>
  <div class="container-list">
    <!-- <div class="common-page common-head ml20">
            <div class="common-page common-head-title ">
                <i class="icon-tr--detailed" style="padding-right: 5px"></i>
                上报火警单位列表
            </div>
           <div class="common-page common-head-end" @click="$router.back()">
               <i class="icon-tr-sign-out"></i>
           </div>   
        </div> -->
    <div class="common-page common-body">
      <div class="common-page common-tool-bar">
        <div class="btn" @click="showDia = true">
          <i class="icon-tr-search"></i>查询
        </div>
      </div>
      <div class="common-page common-list">
        <table
          class="table table-bordered"
          id="detailtable"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th>上报单位</th>
              <th>联系电话</th>
              <th>上报日期</th>
              <th>上报内容</th>
              <th style="">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list" :key="index">
              <td>{{ item.c_name }}</td>
              <td>{{ item.c_phone }}</td>
              <td>{{ item.nowtime }}</td>
              <td>{{ item.remark }}</td>
              <td>
                <router-link
                  :to="{
                    path: '/jiejing/jiejingdetail',
                    query: { id: item.c_number },
                  }"
                >
                  <el-button type="warning" size="mini" plain>详情</el-button>
                </router-link>

                <el-button
                  size="mini"
                  slot="reference"
                  type="danger"
                  plain
                  @click="dt(item)"
                >
                  处理
                </el-button>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <el-table :data="list" class="">
          <el-table-column prop="c_name" label="上报单位" align="center">
          </el-table-column>
          <el-table-column prop="c_phone" align="center" label="联系电话">
          </el-table-column>
          <el-table-column prop="nowtime" align="center" label="上报日期">
          </el-table-column>
          <el-table-column prop="remark" align="center" label="上报内容">
          </el-table-column>

          <el-table-column label="操作" align="center" width="160px">
            <template slot-scope="scope">
              <router-link
                :to="{ path: '/jiejing/jiejingdetail', query: { id: scope.row.c_number } }"
              >
                <el-button type="warning" size="mini" plain >详情</el-button>
              </router-link>

              <el-button
                size="mini"
                slot="reference"
                type="danger"
                plain
                @click="dt(scope.row)"
              >
                处理
              </el-button>

            </template>
          </el-table-column>
        </el-table> -->
        <el-dialog
          :title="`处理${unitInfo.c_name}火警信息`"
          style="min-height: 500px"
          :visible.sync="dtmod"
          width="30%"
          :close-on-click-modal="false"
        >
          <el-form ref="form" v-model="unitInfo" label-width="110px">
            <el-form-item prop="tr_name" label="火警单位:">
              {{ unitInfo.hj_name }}
            </el-form-item>
            <el-form-item prop="tr_name" label="上传单位:">
              {{ unitInfo.c_name }}
            </el-form-item>
            <el-form-item prop="tr_name" label="上传时间:">
              {{ unitInfo.nowtime }}
            </el-form-item>
            <el-form-item prop="tr_name" label="上传用户:">
              {{ unitInfo.sc_user }}
            </el-form-item>
            <el-form-item prop="tr_name" label="处理时间:">
              {{ unitInfo.cl_time }}
            </el-form-item>
            <el-form-item prop="tr_name" label="处理用户:">
              {{ unitInfo.cl_user }}
            </el-form-item>
            <el-form-item prop="tr_name" label="处理意见:">
              <el-input type="textarea" v-model="unitInfo.cl_yijian"></el-input>
            </el-form-item>
          </el-form>
          <div class="center">
            <el-button type="primary" @click="changeStatus">确认处理</el-button>
            <el-button @click="dtmod = false">取消</el-button>
          </div>
        </el-dialog>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="params.limit || 10"
        @current-change="pageChange"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      >
      </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="cancle" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList, editUser } from "../../api/user";
import { get, post } from "@/utils/http.js";

import { getTime } from "../../api/common";

import { mapState } from "vuex";

export default {
  data() {
    return {
      list: [],
      params: {
        page: 1,
        c_name: "",
        starttime: "",
        endtime: "",
        c_belong_profession: "",
      },
      total: 0,
      showDia: false,
      dtmod: false, // 处理mode
      searchForm: this.$getForm("jiejingsearch"),
      editData: {},
      unitInfo: {
        hj_name: "同人监控平台",
        c_name: "",
        cl_time: "",
        cl_user: this.$store.state.user.userInfo.nickName,
        cl_yijian: "",
      },
      remoteFuncs: {
        getSelect(resolve) {
          post("/devicemanage/mapcode", { mc_parent_id: 66 }).then((res) => {
            resolve(res.data);
          });
        },
      },
    };
  },
  computed: {
    ...mapState(["isMute", "isWaring", "jjList", "isLoop", "showFire"]),
  },

  watch: {
    isWaring(val) {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  methods: {
    showDt(it) {
      console.log(it);
    },
    dt(it) {
      this.clearCL();
      this.unitInfo = { ...this.unitInfo, ...it };
      this.getTime();

      console.log(this.unitInfo);
      this.dtmod = true;
    },

    changeStatus(it, del) {
      this.$post(`/user/chuli`, this.unitInfo).then((res) => {
        // this.$message.success("操作成功");
        this.$message({
									message: '操作成功',
									type: 'success',
									duration: 700,
								});
        this.getList();
        this.dtmod = false;
      });
    },
    clearCL() {
      this.unitInfo = {
        hj_name: "同人监控平台",
        c_name: "",
        cl_time: "",
        cl_user: this.$store.state.user.userInfo.nickName,
        cl_yijian: "",
      };
    },

    getTime() {
      // getTime().then((data) => {
      // let time = data.sysTime2.replace(/-/g, "/");
      let time = new Date(+new Date() + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace("T", " ")
        .replace(/-/g, "/");

      let timeLine = new Date(time).getTime();
      // console.log()

      this.unitInfo.cl_time = new Date(timeLine).Format("yy-MM-dd hh:mm:ss");
      this.uploadmod = true;
      // });
      // console.log()
    },

    cancle() {
      this.showDia = false;
      this.resetSearch();
    },
    getList() {
      console.log(this.params);
      this.$post("/user/jjlist", this.params)
        .then((res) => {
          this.total = res.count;
          this.list = res.list;
        })
        .catch((err) => {});
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped>
.table > tbody > tr > td,
.table > tbody > tr > th,
.table > tfoot > tr > td,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > thead > tr > th {
  padding: 8px;
  vertical-align: top;
  text-align: center;
  border-top: 1px solid #ddd;
}
.table-bordered > thead > tr > th,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > tbody > tr > td,
.table-bordered > tfoot > tr > td {
  border: 1px solid #dddddd;
}
</style>
